import "./customizeApplication.scss"
import ProgressBar from "../../../Components/ProgressBar/ProgressBar"
import CheckboxInput from "../../../Components/Input/CheckboxInput"
import { useNavigate } from "react-router-dom"
import { useEffect, useState } from "react"
import axios from "axios"
import HandleLoginRedirect from "API/HandleLoginRedirect"
import Cookies from "universal-cookie"
import config from "../../../config/config"
import Helmet from "react-helmet"

function CustomizeApplication() {
  let navigate = useNavigate()
  const cookies = new Cookies()

  const [currentHousingChecked, setCurrentHousingChecked] =
    useState(false)
  const [previousHousingChecked, setPreviousHousingChecked] =
    useState(false)
  const [employmentInfoChecked, setEmploymentInfoChecked] =
    useState(false)
  const [householdInfoChecked, setHouseholdInfoChecked] =
    useState(false)
  const [guarantorInfoChecked, setGuarantorInfoChecked] =
    useState(false)

  const handleChange = (e) => {
    switch (e.target.name) {
      case "current_housing":
        setCurrentHousingChecked(e.target.checked)
        break
      case "previous_housing":
        setPreviousHousingChecked(e.target.checked)
        break
      case "employment_info":
        setEmploymentInfoChecked(e.target.checked)
        break
      case "household":
        setHouseholdInfoChecked(e.target.checked)
        break
      case "guarantor":
        setGuarantorInfoChecked(e.target.checked)
        break
    }
  }

  const apiConfig = {
    headers: {
      Authorization: "Bearer " + cookies.get("auth_token"),
    },
  }
  const handleSubmit = () => {
    try {
      let updatedRequirements = []

      // From postman
      // (array) ['monthly_rent_payment', 'current_residence_duration', 'employment_info', 'pet_ownership', 'parking', 'proof_of_income', 'smoking', 'household_income']
      if (currentHousingChecked) {
        updatedRequirements.push("monthly_rent_payment")
        updatedRequirements.push("current_residence_duration")
      }
      if (previousHousingChecked) {
        // @todo standby confirming with api to see why this isn't in postman.
        //updatedRequirements.push('previous_housing');
      }
      if (employmentInfoChecked) {
        updatedRequirements.push("employment_info")
        updatedRequirements.push("proof_of_income")
      }
      if (householdInfoChecked) {
        updatedRequirements.push("pet_ownership")
        updatedRequirements.push("parking")
        updatedRequirements.push("smoking")
        updatedRequirements.push("household_income")
      }
      if (guarantorInfoChecked) {
        // @todo standby confirming with api to see why this isn't in postman.
        //updatedRequirements.push('guarantor_info');
      }

      let updatedData = {
        status: "active",
        requirements: updatedRequirements,
      }

      axios
        .post(
          `${config.BASE_URL}api/application/` +
            cookies.get("current_property_application_id"),
          updatedData,
          apiConfig
        )
        .then(function (response) {
          // handle response.
          if (response.data.status == 1) {
            navigate("/landlord/application-invite")
          } else {
            // @todo throw error.
          }
        })
    } catch (err) {}
  }

  return (
    <section className="CustomizeApplication">
      <Helmet>
        <meta charSet="utf-8" />
        <title>
          Smart Screening - Customize Application | Rent Panda
        </title>
        <meta
          name="description"
          content="Start customizing your application for tenants to best fit for your property."
        />
      </Helmet>
      <div className="container">
        <button
          className="btn btn--back"
          onClick={() => {
            navigate("/landlord/property/path")
          }}
        >
          back
        </button>
        <ProgressBar type="landlord" step="4" />

        <h1>customize your application</h1>

        <div className="row">
          <div className="col-lg-8">
            <h3>
              what information would you like to get from tenants?
            </h3>
            <p>Please choose all the options that apply</p>
          </div>
        </div>

        <div className="CustomizeApplication__selections">
          <div className="row">
            <div className="col-lg-4">
              <CheckboxInput
                type="checkbox"
                label="current housing"
                name="current_housing"
                onChange={(e) => handleChange(e)}
                isMega="true"
              >
                Whether the applicant owns or rents, what their
                monthly housing expenses are, how long they’ve been
                there and why they are leaving.
              </CheckboxInput>
            </div>
            <div className="col-lg-4">
              <CheckboxInput
                type="checkbox"
                label="previous housing"
                name="previous_housing"
                onChange={(e) => handleChange(e)}
                isMega="true"
              >
                Where the applicant has lived, for how long, what
                their monthly housing expenses were and why they left
                the home/s.
              </CheckboxInput>
            </div>
            <div className="col-lg-4">
              <CheckboxInput
                type="checkbox"
                label="employment info (income, status, references)"
                name="employment_info"
                onChange={(e) => handleChange(e)}
                isMega="true"
              >
                What the applicant's monthly income is, where they
                work/where the income is from, employment details,
                employment references.
              </CheckboxInput>
            </div>
            <div className="col-lg-4">
              <CheckboxInput
                type="checkbox"
                label="household info"
                name="household"
                onChange={(e) => handleChange(e)}
                isMega="true"
              >
                Number of people in the household, pets details,
                smoking, accessibility needs, total monthly income of
                household, intended duration to rent.
              </CheckboxInput>
            </div>

            <div className="col-lg-4">
              <span className="disabled">
                {/* <CheckboxInput
                type="checkbox"
                label="guarantor info"
                name="guarantor"
                onChange={e => handleChange(e)}
                isMega="true"
              >
                Guarantor personal details,
                contact info, income and
                identification.

              </CheckboxInput>*/}
                Guarantor personal details, contact info, income and
                identification.
              </span>
              <div className="comingSoon">
                <h3 className="comingText">coming soon!</h3>
              </div>

              <div className="comingPadding">
                <div className="comingSoon">
                  <h3 className="comingText">coming soon!</h3>
                </div>
              </div>
            </div>
          </div>

          <div className="CustomizeApplication__premium-details">
            <div className="row">
              <div className="col-lg-8">
                <h3 className="my-2">
                  Once tenants complete their basic application,
                  you'll be able to get advanced information on the
                  applicants you want.
                </h3>
              </div>
            </div>
            <div className="row justify-content-between CustomizeApplication__premium-options">
              <div className="col-lg-4">
                <div className="CustomizeApplication__premium-option poweredBox">
                  <div className="application-preview-badge">
                    <div className="application-preview-badge__inner">
                      <span>powered by</span>
                      <svg
                        width="101"
                        height="21"
                        viewBox="0 0 101 21"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clipPath="url(#clip0_696_893)">
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M15.869 3.67511L16.5042 0.640137H3.35906L1.6175 8.98632L0.138672 15.7076H13.6528L14.3389 12.5101H6.84308L7.52918 9.25759H13.8638L14.5499 6.22447H8.21573L8.74391 3.67835L15.869 3.67511Z"
                            fill="white"
                          />
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M26.9027 9.25764H31.493C31.7323 8.05773 31.9083 6.84558 32.0203 5.62641C32.088 5.00275 31.9677 4.37282 31.6753 3.82076C31.383 3.2687 30.9324 2.82078 30.384 2.53681C28.7019 1.57947 26.2229 1.62993 24.3661 1.56142C21.82 1.46883 18.7907 1.80353 17.1871 4.10754C16.3598 5.29681 15.8943 7.13881 15.7114 8.57945C15.4845 10.3386 14.6224 13.2861 16.1842 14.7304C17.3459 15.8063 19.9451 16.1655 21.4561 16.1423C22.9815 16.1414 24.5035 15.9956 26.0024 15.7067L29.9611 20.6393H36.1395L26.9027 9.25764ZM26.2161 9.36596C25.7111 11.7028 25.0232 13.6684 22.3627 13.6481C19.6914 13.6268 20.5776 10.6955 20.8322 8.98683C21.192 6.55968 22.1054 4.01402 24.8439 4.21864C27.6155 4.42325 26.6377 7.42351 26.2157 9.36596H26.2161ZM51.5545 2.32062L50.1292 8.98683L48.7039 15.7081H54.0888L56.9929 2.32062H51.5545ZM70.1884 4.97646L70.8237 2.32062H59.0498L56.1992 15.7081H61.6367L62.851 9.96268H68.1823L68.3933 8.98683L68.7109 7.46887H63.4309L63.9591 4.97646H70.188H70.1884Z"
                            fill="white"
                          />
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M34.2392 2.32055H39.7298L37.6697 11.8055C37.4183 12.9629 38.4783 13.5698 39.3872 13.6513C39.9607 13.7053 40.5335 13.5415 40.9959 13.1912C41.4583 12.841 41.7777 12.3289 41.8929 11.7532L44.0574 2.32287H49.4944L47.3299 12.3495C46.4033 14.9637 44.2566 15.9904 41.8847 16.2464C40.4061 16.3754 38.9172 16.3041 37.4569 16.0344L32.6016 10.0728L34.2392 2.32055ZM82.3816 2.32055H89.2961L91.4075 5.78929L94.8384 2.32055H100.118L93.2031 8.55299L97.7407 15.7076H90.9851L88.7684 11.6421L84.9681 15.7076H76.891L76.5734 12.7805H70.9794L69.0254 15.7076H65.2251L74.4103 2.32009H81.009L82.2754 13.1592L86.6561 9.03907L82.3807 2.31824L82.3816 2.32055ZM72.774 9.90799L75.7299 5.35507L76.258 9.90799H72.7745H72.774Z"
                            fill="white"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_696_893">
                            <rect
                              width="99.9799"
                              height="20"
                              fill="white"
                              transform="translate(0.138672 0.640137)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    </div>
                  </div>
                  <div className="textBox">
                    <h4>credit check</h4>
                    <p>
                      Detailed credit report including credit score,
                      who they owe money to and how much, all cases
                      sent to collections and past bankruptcies.{" "}
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="CustomizeApplication__premium-option">
                  <h4>ID verification</h4>
                  <p>
                    Verified government ID and face matching
                    technology to ensure safety and security.{" "}
                  </p>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="CustomizeApplication__premium-option">
                  <h4>background check</h4>
                  <p>
                    Exposes any criminal record, shows Landlord and
                    Tenant Board appearances, analyzes their social
                    media profiles and checks all public records.{" "}
                  </p>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="CustomizeApplication__premium-option">
                  <h4>verified landlord references</h4>
                  <p>
                    Real reviews from past landlords who have been
                    verified through lease and landlord ID matching
                    technology.{" "}
                  </p>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="CustomizeApplication__premium-option">
                  <h4>personalized video</h4>
                  <p>
                    Get a video of your applicants so you can get to
                    know them and do your 'gut' check, before you meet
                    in person.{" "}
                  </p>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="CustomizeApplication__premium-option poweredBox">
                  <div className="application-preview-badge">
                    <div className="application-preview-badge__inner">
                      <span>powered by</span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        xlink="http://www.w3.org/1999/xlink"
                        width="101"
                        height="20"
                        viewBox="0 0 101 20"
                        fill="none"
                      >
                        <g clipPath="url(#clip0_701_923)">
                          <rect
                            x="0.466797"
                            width="77.2414"
                            height="20"
                            fill="url(#pattern0)"
                          />
                        </g>
                        <defs>
                          <pattern
                            id="pattern0"
                            patternContentUnits="objectBoundingBox"
                            width="1"
                            height="1"
                          >
                            <use
                              href="#image0_701_923"
                              transform="translate(-0.00571987) scale(0.00404576 0.015625)"
                            />
                          </pattern>
                          <clipPath id="clip0_701_923">
                            <rect
                              width="100"
                              height="20"
                              fill="white"
                              transform="translate(0.466797)"
                            />
                          </clipPath>
                          <image
                            id="image0_701_923"
                            width="250"
                            height="64"
                            href="data:image/png;base64,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"
                          />
                        </defs>
                      </svg>
                    </div>
                  </div>

                  <div className="textBox">
                    <h4>income & expenses verification</h4>
                    <p>
                      We scan their bank statements, access their pay
                      stubs and measure their expenses with details
                      directly from the bank.{" "}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="btn-group">
            <button
              className="btn btn--primary"
              onClick={() => {
                handleSubmit()
              }}
            >
              next
            </button>
          </div>
        </div>
      </div>
    </section>
  )
}

export default CustomizeApplication
